import { Component, Input, OnInit } from '@angular/core';
import { EmailOptInMetaDataLego } from '../../shared/dto/email-optin-metadata.lego';

@Component({
  selector: 'wl-email-optin-lego-summary',
  templateUrl: './email-optin-lego-summary.component.html',
  styleUrls: ['./email-optin-lego-summary.component.less'],
    standalone: false
})
export class EmailOptInLegoSummaryComponent implements OnInit {
  @Input() emailOptInData: EmailOptInMetaDataLego;
  constructor() {}
  ngOnInit(): void {}
}
